import type { ComponentChildren, JSX } from 'preact';
import { Flex } from '../UNSAFE_Flex';
import { Layer } from '../UNSAFE_Layer';
import { WindowOverlay } from '../UNSAFE_WindowOverlay';
import type { UnpackSignals } from '@oracle/oraclejet-internal-utilities/attributeUtils';
import { mobileDropdownStyles } from './themes/mobileDropdownStyles.css';

type Props = {
  /**
   * Id of the label to associate with the dropdown (e.g. the label of the filter field).
   */
  'aria-labelledby'?: UnpackSignals<JSX.AriaAttributes>['aria-labelledby'];

  /**
   * The dropdown content
   */
  children?: ComponentChildren;

  /**
   * The id for the top level element
   */
  id?: string;

  /**
   * Specifies whether the dropdown is being shown
   */
  isOpen?: boolean;
};

export function MobileDropdown({ 'aria-labelledby': ariaLabelledBy, children, id, isOpen }: Props) {
  return !isOpen ? null : (
    <Layer>
      <WindowOverlay>
        <div
          id={id}
          class={mobileDropdownStyles.base}
          role="dialog"
          aria-modal="true"
          aria-labelledby={ariaLabelledBy}>
          <Flex width="100%" height="100%" maxHeight="100%" direction="column">
            {children}
          </Flex>
        </div>
      </WindowOverlay>
    </Layer>
  );
}
